import {Request, ResponseSerialize} from '@simpli/serialized-request'
import {IResource} from '@simpli/resource-collection/dist/types/IResource'
import {GithubRepository} from './GithubRepository'
import {GithubUser} from './GithubUser'

export class GithubRepositoryCommit implements IResource {
  idGithubRepositoryCommitPk: number = 0

  @ResponseSerialize(GithubRepository)
  githubRepository: GithubRepository | null = null

  @ResponseSerialize(GithubUser)
  githubUser: GithubUser | null = null

  message: string | null = null
  url: string | null = null
  sha: string | null = null
  committedAt: Date | null = null
  createdAt: Date | null = null

  get $id() {
    return this.idGithubRepositoryCommitPk
  }

  set $id(val) {
    this.idGithubRepositoryCommitPk = val
  }

  get $tag() {
    return String(this.message)
  }

  /**
   * Deletes an instance of a given ID of GithubRepositoryCommit
   */
  async removeGithubRepositoryCommit() {
    return await Request.delete(`/client/github-repository-commit/${this.$id}`)
      .name('removeGithubRepositoryCommit')
      .asNumber()
      .getData()
  }
}
